import { Spin, Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface GridListCardCoverProps {
  src?: string;
  alt?: string;
  attribution?: string | null;
  loading?: boolean;
}

export const GridListCardCover = ({ alt, attribution, src, loading = false }: GridListCardCoverProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Spin spinning={loading}>
        <div
          title={alt}
          style={{
            width: '100%',
            paddingTop: '67%',
            position: 'relative',
            backgroundImage: `url(${src})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
      </Spin>

      {attribution && (
        <small style={{ paddingLeft: '8px' }}>
          <Typography.Text type="secondary">
            {t('PREVIEW_IMAGE_ATTRIBUTION', { attribution }) as string}
          </Typography.Text>
        </small>
      )}
    </>
  );
};
